<template>
  <div style="display: flex; justify-content: center">
    <div class="MainDiv">
      <div style="margin-bottom: 1rem">
        <v-img
          src="https://www.bodytalksystem.com/images/access_banner1.jpg"
          contain
        ></v-img>
      </div>
      <div style="display: flex">
        <div
          style="
            max-width: 25%;
            padding-right: 1rem;
            border-right: 1px dashed gray;
          "
        >
          

<p><b>Join our online community</b></p>
<p>A great place to talk to other graduates and get continued education and insight from instructors is on the IBA forum. The forum is one of the benefits you gain from becoming an IBA member. For information on IBA membership <a href="https://www.bodytalksystem.com/membership?utm_source=access-grad&utm_medium=email&utm_campaign=v1&utm_term=membership">click here </a>.<br>
<br></p>

<p><b>The Cortices Video</b></p>
<p>You can now share what you have learnt with your family and friends, by teaching them how to tap out their own cortices. We have a video demonstration of this technique so anyone can learn.
<a href="https://www.youtube.com/watch?v=LqzsfszL4lc&t=75s"><br />Watch now!</a><br>
<br></p>

<p><b>Expand your Knowledge</b></p>
<p>Review our <a href="https://www.bodytalksystem.com/seminars/"> course listings</a> to see how you can expand upon your knowledge of BodyTalk. <br>
<br></p>

<p><b>Become a Practitioner</b></p>
<p>Take BodyTalk to the next level and become a Practitioner.<br>
<br></p>

<p><b>IBA Newsletter</b></p>
<p>Stay up to date with the latest information, happenings and stories in the BodyTalk community.<br>
<a href="http://www.bodytalksystem.com/learn/news/newsletter.cfm?utm_source=access-grad&utm_medium=email&utm_campaign=v1&utm_term=newsletter" style="color: #003366;text-decoration: underline;font-weight: normal;">Sign up today</a><br></p>
        </div>
        <div style="max-width: 75%; padding-left: 1rem">
          <h4><b>Congratulations, #createEvaluation.StudentFname#!</b></h4>
            <p>Congratulations on embarking on this fantastic mind-expanding journey of learning with IBA. We hope you enjoyed your recent class.<br>
            <br></p>

            <p><b>Study Tips:</b></p>
            <p>As you are now aware, the BodyTalk Fundamentals course is full of information and new techniques for optimizing health and wellness. In order to best absorb this information we suggest that you:
            <ul>
                <li>
                    Begin reading one chapter of the BodyTalk Fundamentals textbook a day.</li>
                <li>
                    Find people to practice your BodyTalk sessions with. Get started as soon as you can to encourage retention of the material. For best results and ease of practice, find someone who is open to new ideas and new tools for optimizing health.</li>
                <li>
                    You can also start documenting your BodyTalk Sessions if you are planning to certify.</li>
                <li>
                    If you have questions, and you are an IBA member, go online to the Forum to ask. IBA regularly monitors the forum as well as many students and practitioners. Otherwise, you may want to email your instructor directly.</li>
                <li>
                    To help you process and retain the material, tap out your Cortices to clear your brain and drink some water to hydrate your body and brain. The BodyTalk Access routine is great for supporting your wellbeing and is very useful as preparation for a study session. Remember, it only takes ten minutes.</li>
                </ul>
            </p>

            <p><b>Feedback</b></p>
            <p>We understand that you may have already filled out an evaluation form in class. We are also aware that as you have had some time to process your experience, you may now have other input. This evaluation goes directly to the IBA.
            <br><br>
            It is important for us to gain your feedback so please take a moment to complete our short online Course Evaluation.<br>
            <a href="https://evaluations.bodytalksystem.com/default.aspx?id=#createEvaluation.LinkId#">Click here</a><br><br></p>
            <p><b>Support</b></p>
                <p>If you are interested in having a paid membership with IBA, it is a wonderful way to stay connected to the IBA matrix and strengthen your connection to the material. You will also receive an online video course created by Dr. John Veltheim, the BodyTalk Founder, with tips on setting up a BodyTalk practice and access to the following on our member site:

                <ul>
                    <li>
                        Client intake forms and consent forms</li>
                    <li>
                        Case study forms</li>
                    <li>
                        Downloadable BodyTalk charts</li>
                    <li>
                        Fundamentals Exam preparation tips</li>
                    <li>
                        Study Group tips</li>
                    <li>
                        And much more</li>
                    </ul>


                We want to encourage your success. So, if you are a member you can retake most IBA courses for 75% off! All of our students notice a dramatic increase in understanding the material and becoming more fluent with the muscle-checking process the second time around, as it sinks in at a much deeper level.
                <br><br>
                We look forward to assisting you on this educational journey of self-awareness and wellness.
                <br><br>
                If there is anything that we can help with please email us at <a href="mailto:office@bodytalksystem.com" target="_top">office@bodytalksystem.com</a>.
                <br><br>
                Sincerely,<br>
                The IBA Team<br></p>
                <br>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FundamentalGraduation",
};
</script>

<style scoped>
.MainDiv {
  padding: 2rem;
  align-content: center;
  max-width: 1000px;
}
</style>
